<div class="service-request-status-list-item" id="serviceRequest_{{ serviceRequest.requestReference }}_{{ index }}"
(click)="emitItemDetails(serviceRequest)">
    <div class="service-request-info" >
        <div class="service-request-icon-wrapper">
            <img src="./assets/images/icons/cheque.svg" alt="" />
        </div>
        <ng-container *ngIf="serviceRequest.requestDate; else tracker">
            <div class="service-request-details">
                <div class="service-request-detail-row1">
                    <span class="date">{{ serviceRequest.requestDate.split(' ')[0] | dateFormatter: "yyyy-mm-dd" }}</span>
                    <span class="service-request-desc">{{ serviceRequest.requestTypeDesc }}</span>
                    <span class="service-request-number">{{'SERVICEREQUESTLANDING.ref'| translate}} {{ serviceRequest.requestReference}}</span>
                    <button type="button" class="btn-icon">
                        <img src="./assets/images/icons/arrow-right.svg" alt="">
                    </button>
                </div>
                <div class="service-request-detail-row2">
                    <span [ngClass]="serviceRequest.customerStatus?.toLowerCase()"
                    class="service-request-status">{{ serviceRequest.customerStatus}}</span>
                    <span class="amount">{{serviceRequest.amount}}<em> {{serviceRequest.currencyCode}}</em></span>
                </div>
            </div>
        </ng-container>
        <ng-template #tracker>
            <div class="service-request-details">
                <div class="service-request-detail-row1">
                    <span class="date">{{ serviceRequest.dateTime | dateFormatter: "yyyy-mm-dd" }}</span>
                    <span class="service-request-desc">{{ serviceRequest.taskName }}</span>
                    <!-- <span class="service-request-number">Ref #: {{ serviceRequest.requestReference}}</span> -->
                    <button type="button" class="btn-icon">
                        <img src="./assets/images/icons/arrow-right.svg" alt="">
                    </button>
                </div>
                <div class="service-request-detail-row2">
                    <span [ngClass]="serviceRequest.stage?.toLowerCase()"
                    class="service-request-status">{{ serviceRequest.stage}}</span>
                    <span class="amount">{{serviceRequest.amount}}<em> {{serviceRequest.currencyCode}}</em></span>
                </div>
            </div>
        </ng-template>
    </div>
    <div class="row-action row-action-right">
        <button type="button" class="button-row-action"><span>Complete</span></button>
    </div>

</div>